import React from "react";
import { Grid } from "@material-ui/core";
import { format } from "date-fns";
import numeral from "numeral";

import { BreakevenLineChart, RefiAnalysisLineChart } from "..";
import "./styles.css";

const TakeawaySection = props => {
  const {
    breakevenPercent,
    costSavingsResult,
    tenYearTreasuryYield,
    refiType,
    maturityDate,
    companyPrimaryColor,
    companySecondaryColor
  } = props;

  const BreakevenText = () => (
    <>
      <div className="takeaway-section-body-text">
        If the all-in coupon on the new financing in the future is above
        {numeral(breakevenPercent).format("0.00%")}
        , the Borrower would have been better off refinancing today.
      </div>
      <br />
      <div className="takeaway-section-body-text">
        Assuming spreads remain the same, this implies a
        <strong>
          10 Year Treasury yield of
          {numeral(tenYearTreasuryYield).format("0.00%")}
          .
        </strong>
      </div>
    </>
  );

  const RefiAnalysisText = () => (
    <>
      <div className="takeaway-section-body-text">The interest savings of refinancing this loan outweighs the cost of prepayment.</div>
      <br />
      <div className="takeaway-section-body-text">
        Including your penalty, you would save
        {numeral(costSavingsResult).format("$0,0")}
        {" "}
        between now and
        {maturityDate ? format(Date.parse(maturityDate), "MM/dd/yyyy") : "--"}
        {" "}
        by refinancing today.
      </div>
    </>
  );

  return (
    <Grid container item direction="row" className="takeaway-section-wrapper">
      <Grid item xs={5}>
        <div className="takeaway-section-text-wrapper">
          <div className="takeaway-section-title">THE TAKEAWAY</div>
          <br />
          {refiType === "Refi Breakeven" ? <BreakevenText /> : <RefiAnalysisText />}
        </div>
      </Grid>
      <Grid container item xs={7} className="takeaway-section-chart-wrapper">
        <Grid item xs={12} style={{ border: `1px solid ${companyPrimaryColor}` }}>
          <div className="takeaway-section-chart">
            {
              refiType === "Refi Breakeven" ?
                <BreakevenLineChart companyPrimaryColor={companyPrimaryColor} companySecondaryColor={companySecondaryColor} /> :
                <RefiAnalysisLineChart companyPrimaryColor={companyPrimaryColor} companySecondaryColor={companySecondaryColor} />
            }
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TakeawaySection;
